import React from "react";
import './SeatsPickerInitiator.scss'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DatesSelector } from "./DatesSelector";
import { usePickerContext } from "../hooks/usePickerContext";

export function SeatsPickerInitiator({...props}) {

    const { state } = usePickerContext();

    return (
        <div className={'SeatsPickerInitiator'}>
            {!!state.labels.title && <span className="SeatsPickerInitiator-title">{state.labels.title}</span>}
            <div className="SeatsPickerInitiator-engine">
                {state.typeWidget === 'FREE' &&
                <DatesSelector/>
                }
                <button className={'SeatsPickerInitiator-button'} onClick={props.onSearch}>
                    <span>{state.labels.WIDGET_RESA_BOUTON_RECHERCHER || "Rechercher"}</span>
                    <FontAwesomeIcon icon={faSearch} style={{ marginLeft: 10 }}/>
                </button>
            </div>
        </div>
    );
}